<template>
  <section>
    <qx-img-dialog ref="imgDialog" />
    <EditDialog ref="editDialog" @sub="handleEditSub" :orgId="orgId" :serviceInfo="serviceInfo" />
    <span class="primary cur" @click="showEdit()">添加</span>
    <!-- 表格 -->
    <section class="tableBox" v-show="resultVal.length !== 0">
      <el-table
        v-loading="tableData.loading"
        ref="multipleTable"
        :data="resultVal"
        tooltip-effect="dark"
      >
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minW"
          :width="item.w"
        >
          <section slot-scope="scope">
            <section v-if="scope.column.property === 'detailPic'">
              <span
                class="primary cur"
                v-for="(item, index) in scope.row.detailPic"
                style="margin-right: 8px;"
                :key="index"
                @click="previewImg(item.url)"
              >{{'附件' + (index+1)}}</span>
            </section>
            <section
              v-if="scope.column.property !== 'detailPic'"
            >{{scope.row[scope.column.property]}}</section>
          </section>
        </el-table-column>
        <!-- 常规列表项 end -->
        <!-- 操作按钮 -->
        <el-table-column prop="control" label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <section>
              <!-- 操作按钮 -->
              <qx-permpisions permpisions>
                <span class="primary cur" @click="showEdit(scope.row)">修改</span>
              </qx-permpisions>
              <qx-permpisions permpisions>
                <span class="primary cur" @click="del(scope.row)">删除</span>
              </qx-permpisions>
              <!-- 操作按钮 end -->
            </section>
          </template>
        </el-table-column>
        <!-- 操按钮 end -->
      </el-table>
    </section>
    <!-- 表格 end -->
  </section>
</template>

<script>
import EditDialog from './editDialog';
export default {
  components: {
    EditDialog,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'cc',
  },
  props: {
    resultVal: {
      type: Array,
      default: () => ([]),
    },
    orgId: {
      type: Number,
    },
    serviceInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
          // 找不到这个字段哪里可以填写
          // {
          //   prop: 'userName',
          //   label: '司机姓名',
          // },
          {
            prop: 'feeAscriptionDate',
            label: '维修日期',
          },
          {
            prop: 'payAmt',
            label: '维修费用',
          },
          {
            prop: 'serviceName',
            label: '服务商',
          },
          {
            prop: 'productName',
            label: '维修网点',
          },
          {
            prop: 'repairReson',
            label: '维修内容',
          },
          {
            prop: 'detailPic',
            label: '附件',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    showEdit (item) {
      this.$refs.editDialog.show(item);
    },
    handleEditSub ({ form, originData }) {
      if (originData) {
        const index = this.resultVal.indexOf(originData);
        this.resultVal.splice(index, 1, form);
      } else {
        this.resultVal.push(form);
      }
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
    previewImg (url) {
      this.$refs.imgDialog.show(url);
    },
    del (item) {
      this.resultVal.splice(this.resultVal.indexOf(item), 1);
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
  },
};
</script>

<style>
</style>
